// ???? ?????? ???? ???????? Nginx ?? ???? ?????? ??????
export const API_URL = 'https://puzzlify.net/api';
export const SITE_URL = 'https://puzzlify.net';